module.exports = __webpack_public_path__ + "img/image7.d1a14ab7.png";